import {
	SNOWPLOW_ENTITY,
	SNOWPLOW_ENTITY_SCHEMA,
	SNOWPLOW_ENTITY_SCHEMA_VERSION,
	SNOWPLOW_ENVIRONMENT,
} from "./conf";

export const snowplowLog = (...args) => {
	console.warn("[DISCOPLOW]:", ...args);
};
export const isValidSnowplowEntity = ({ entity = "" } = {}) =>
	!!(entity in SNOWPLOW_ENTITY);

export const isValidSnowplowEnvironment = ({ environment = "" } = {}) =>
	!!(environment in SNOWPLOW_ENVIRONMENT);

export const getSnowplowEventSchema = ({
	event = "",
	environment = SNOWPLOW_ENVIRONMENT.PRODUCTION,
	eventSchemaVersionMap = {},
	eventSchemaMap = () => {},
} = {}) => {
	if (!(event in eventSchemaVersionMap)) {
		snowplowLog("getSnowplowEventSchema >>", "Invalid event");
		return "";
	}
	if (!isValidSnowplowEnvironment({ environment })) {
		snowplowLog("getSnowplowEventSchema >>", "Invalid environment");
		return "";
	}

	const schemaVersion = eventSchemaVersionMap[event][environment];
	const schema = eventSchemaMap({ version: schemaVersion })[event];
	return schema;
};
export const getSnowplowEntitySchema = ({
	environment = SNOWPLOW_ENVIRONMENT.PRODUCTION,
	entity = "",
} = {}) => {
	if (!isValidSnowplowEntity({ entity })) {
		snowplowLog("getSnowplowEntitySchema >>", "Invalid entity");
		return "";
	}
	if (!isValidSnowplowEnvironment({ environment })) {
		snowplowLog("getSnowplowEntitySchema >>", "Invalid environment");
		return "";
	}

	const schemaVersion = SNOWPLOW_ENTITY_SCHEMA_VERSION[entity][environment];
	const schema = SNOWPLOW_ENTITY_SCHEMA({ version: schemaVersion })[entity];
	return schema;
};

export const snowplowStructGenerator = ({ schema = "", data = {} } = {}) => {
	if (typeof schema !== "string" || !schema) {
		snowplowLog("snowplowStructGenerator >>", "Invalid schema");
		return null;
	}
	if (typeof data !== "object") {
		snowplowLog("snowplowStructGenerator >>", "Invalid data");
		return null;
	}
	return {
		schema,
		data,
	};
};
